import formatMoney from '../formatMoney';
import { getDisplaySavingsCents, getDisplaySavingsPercent } from '../vatBasis';

const replaceToken = (template, token, value) =>
  String(template || '').replace(new RegExp(`\\{${token}\\}`, 'g'), value);

/**
 * PDP sale line: "{percent}% Off - Save a total of {amount}"
 * Percent + savings match what you see on compare-at vs sale (per-line VAT rounding).
 */
const formatPdpSaleSummary = (salePriceCents, compareAtCents) => {
  const compare = Number(compareAtCents) || 0;
  const salePrice = Number(salePriceCents) || 0;

  if (compare <= salePrice) return '';

  const percent = getDisplaySavingsPercent(compare, salePrice);
  const amount = formatMoney(getDisplaySavingsCents(compare, salePrice), window.theme.moneyFormat);

  const percentPart = replaceToken(window.theme?.strings?.pdpPercentOff, 'percent', String(percent));
  const savePart = replaceToken(window.theme?.strings?.pdpSaveTotal, 'amount', amount);

  if (percentPart && savePart) {
    return `${percentPart} - ${savePart}`;
  }

  return `${percent}% Off - Save a total of ${amount}`;
};

export default formatPdpSaleSummary;

const HIDDEN_CLASS = 'hidden';
const ATTR_VAT_AMOUNT = 'data-vat-amount';

/**
 * Recompute PDP sale badge copy from canonical cents on price nodes + current VAT mode.
 * Runs after VAT callbacks so inc/ex always matches on-screen prices even if a callback throws.
 */
export function refreshPdpSaleBadgesFromDom() {
  const priceEl = document.querySelector('[data-product-price]');
  if (!priceEl) return;
  const saleRaw = priceEl.getAttribute(ATTR_VAT_AMOUNT);
  if (saleRaw == null) return;
  const sale = parseInt(saleRaw, 10);
  if (Number.isNaN(sale)) return;

  const compareEl = document.querySelector('[data-product-compare-at-price]');
  let compare = sale;
  if (
    compareEl &&
    compareEl.hasAttribute(ATTR_VAT_AMOUNT) &&
    !compareEl.classList.contains(HIDDEN_CLASS)
  ) {
    const c = parseInt(compareEl.getAttribute(ATTR_VAT_AMOUNT), 10);
    if (!Number.isNaN(c)) compare = c;
  }

  const summary = formatPdpSaleSummary(sale, compare);
  document
    .querySelectorAll(
      '[data-product-sale-badge] [data-sale-badge-text], [data-sticky-product-sale-badge] [data-sale-badge-text]'
    )
    .forEach((el) => {
      el.textContent = summary;
    });
}
